// extracted by mini-css-extract-plugin
module.exports = {"h3":"iJ7OVZ","base":"mmwOFv","wrapper":"_2nQxPF","cuttingDetail":"hLLOS-"};